import React from 'react';
import './AboutUs.css';
import officeImage from '../assets/office.png';

const AboutUs: React.FC = () => {
  return (
    <section id="about" className="about-section section-alt">
      <div className="container about-container">
        <div className="about-content">
          <h2>About Us</h2>
          <div className="about-text">
            <p>
              TRI-BAY ELECTRIC, INC. is a commercial based Electrical Contractor with our office headquarters in San Jose, Ca.
              We have been in the Electrical Contracting Industry since the 1980's.
            </p>
            <p>
              Our decades of experience have enabled us to build an exceptional skill set that can immediately meet your needs.
              Our experience and purchasing knowledge will enable us to complete your project in a cost-competitive and timely manner.
            </p>
            <p>
              All of our management staff and field electricians have completed Electrical training programs, take continuing education
              classes and are all certified by the State of California as well as members of The International Brotherhood of Electrical Workers (IBEW).
              TRI-BAY ELECTRIC'S commitment to extensive training provides us with highly skilled employees.
            </p>
            <p className="about-cta">
              We would welcome the opportunity to work with you on your upcoming projects.
              We are ready to meet the challenges unique to your needs.
            </p>
          </div>
        </div>
        <div className="about-image-container">
          <img src={officeImage} alt="Tri-Bay Electric Office" className="about-image" />
        </div>
      </div>
    </section>
  );
};

export default AboutUs; 